"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "InitMetaServiceProvider", {
    enumerable: true,
    get: function() {
        return InitMetaServiceProvider;
    }
});
const _debug = require("nc-gui/utils/debug");
const _verifyDefaultWorkspace = require("~/helpers/verifyDefaultWorkspace");
const _utils = require("~/utils");
const _populateCloudPlugins = require("~/utils/cloud/populateCloudPlugins");
const _metaservice = require("~/meta/meta.service");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NcPluginMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/helpers/NcPluginMgrv2"));
const _NcUpgrader = /*#__PURE__*/ _interop_require_default(require("~/version-upgrader/NcUpgrader"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _getInstance = /*#__PURE__*/ _interop_require_default(require("~/utils/getInstance"));
const _initAdminFromEnv = /*#__PURE__*/ _interop_require_default(require("~/helpers/initAdminFromEnv"));
const _models = require("~/models");
const _ncconfig = require("~/utils/nc-config");
const _globals = require("~/utils/globals");
const _migrationJobs = require("~/helpers/migrationJobs");
const _initBaseBehaviour = require("~/helpers/initBaseBehaviour");
const _initDataSourceEncryption = /*#__PURE__*/ _interop_require_default(require("~/helpers/initDataSourceEncryption"));
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const InitMetaServiceProvider = {
    // initialize app,
    // 1. init cache
    // 2. init db connection and create if not exist
    // 3. init meta and set to Noco
    // 4. init jwt
    // 5. init plugin manager
    // 6. run upgrader
    useFactory: async (eventEmitter, appHooksService)=>{
        // NC_DATABASE_URL_FILE, DATABASE_URL_FILE, DATABASE_URL, NC_DATABASE_URL to NC_DB
        await (0, _ncconfig.prepareEnv)();
        const config = await _ncconfig.NcConfig.createByEnv();
        _debug.NcDebug.log('Config prepared using environment variables');
        // set version
        process.env.NC_VERSION = '0258003';
        // set migration jobs version
        process.env.NC_MIGRATION_JOBS_VERSION = '9';
        // init cache
        await _NocoCache.default.init();
        _debug.NcDebug.log('Cache initialized');
        // init meta service
        const metaService = new _metaservice.MetaService(config);
        // check if nc_store exists
        const ncStoreExists = await metaService.knexConnection.schema.hasTable(_globals.MetaTable.STORE);
        // get instance config
        const instanceConfig = ncStoreExists ? await metaService.metaGet(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, {
            key: 'NC_CONFIG_MAIN'
        }) : null;
        // Avoid upgrading directly from versions lower than 0100002 (NC_VERSION)
        if (instanceConfig) {
            const configObj = JSON.parse(instanceConfig.value);
            if (+configObj.version < 100002) {
                throw new Error(`You are trying to upgrade from an old version of NocoDB. Please upgrade to 0.207.3 first and then you can upgrade to the latest version.`);
            }
        } else {
            var _this;
            // if bases are present then it is an old version missing the config
            const isOld = (_this = await metaService.legacyProjectList()) == null ? void 0 : _this.length;
            if (isOld) {
                throw new Error(`You are trying to upgrade from an old version of NocoDB. Please upgrade to 0.207.3 first and then you can upgrade to the latest version.`);
            }
        }
        const v0TableExists = await metaService.knexConnection.schema.hasTable('xc_knex_migrationsv0');
        const v2TableExists = await metaService.knexConnection.schema.hasTable('xc_knex_migrationsv2');
        const v3TableExists = await metaService.knexConnection.schema.hasTable('xc_knex_migrationsv3');
        _Noco.default.firstEeLoad = _utils.isEE && !v0TableExists && v2TableExists && !v3TableExists;
        await metaService.init();
        _debug.NcDebug.log('Meta service initialized');
        // provide meta and config to Noco
        _Noco.default._ncMeta = metaService;
        _Noco.default.appHooksService = appHooksService;
        _Noco.default.config = config;
        _Noco.default.eventEmitter = eventEmitter;
        await _Noco.default.prepareAuditService();
        if (!instanceConfig) {
            _debug.NcDebug.log('Inserting instance config');
            // bump to latest version for fresh install
            await (0, _migrationJobs.updateMigrationJobsState)({
                version: process.env.NC_MIGRATION_JOBS_VERSION
            });
            _debug.NcDebug.log('Migration jobs state updated');
        }
        // init jwt secret
        await _Noco.default.initJwt();
        _debug.NcDebug.log('JWT initialized');
        // load super admin user from env if env is set
        await (0, _initAdminFromEnv.default)(metaService);
        _debug.NcDebug.log('Admin user from environment initialized');
        await _Noco.default.loadEEState();
        if (process.env.NC_LICENSE_KEY) {
            try {
                await (0, _populateCloudPlugins.populatePluginsForCloud)({
                    ncMeta: _Noco.default.ncMeta
                });
                _debug.NcDebug.log('Cloud plugins initialized from env');
            } catch (e) {
                if (process.env.NC_CLOUD === 'true') throw e;
                console.error('Plugin init failed', e == null ? void 0 : e.message);
            }
        }
        _debug.NcDebug.log('Upgrader starting');
        // run upgrader
        await _NcUpgrader.default.upgrade({
            ncMeta: _Noco.default._ncMeta
        });
        _debug.NcDebug.log('Upgrader finished');
        // init plugin manager
        await _NcPluginMgrv2.default.init(_Noco.default.ncMeta);
        _debug.NcDebug.log('Plugin manager initialized');
        if (process.env.NC_CLOUD === 'true') {
            try {
                await (0, _populateCloudPlugins.populatePluginsForCloud)({
                    ncMeta: _Noco.default.ncMeta
                });
            } catch (e) {
                if (process.env.NODE_ENV !== 'test') throw e;
            }
        }
        _utils.T.init({
            instance: _getInstance.default
        });
        _utils.T.emit('evt_app_started', await _models.User.count());
        // decide base behavior based on env and database permissions
        await (0, _initBaseBehaviour.initBaseBehavior)();
        _debug.NcDebug.log('Base behavior initialized');
        // encrypt datasource if secret is set
        await (0, _initDataSourceEncryption.default)(metaService);
        _debug.NcDebug.log('Datasource encryption initialized');
        await (0, _verifyDefaultWorkspace.verifyDefaultWorkspace)();
        return metaService;
    },
    provide: _metaservice.MetaService,
    inject: [
        'IEventEmitter',
        _apphooksservice.AppHooksService
    ]
};
